import store from "../../store/store"
import colors from "../../helpers/colors"
import('./markers.scss')

export default function MarkersComponent(opts={}){
    BaseConstructor.call(this)
    let {container, map} = opts
    let elements = {}
    let context = this

    let markers_layer, markers_list

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    this.zoomToStation = station =>{
        map.flyTo([(station.latitude || station.station.latitude), (station.longitude || station.station.longitude)],15, {animate: false})
        store.mapConfigStore.setPopupOptions({type:'station_flu', obj:station, obj_id: station.id, show:true})
    }

    this.updateMarkers = _ =>{
        //criar marcadores caso necessário
        creatMarkers()
    }

    this.filterMarkers = _ =>{
        markers_layer.clearLayers()
        let stations = store.fluConfig.getStations()

        stations.forEach(station=>{
            
            let show = true
            let by_reference = true, by_legend = true, by_ugrhi = true, by_city = true, by_value = true


            if(store.mainConfigStore.getOption('hide_all_markers') === false){
                if(store.mainConfigStore.getType() === 'flu'){
                    if(station.marker && station.parameter && hasFluReferenceValues(station.parameter)){

                        by_reference = true
                        by_legend = filterByLegends(station)
                        by_ugrhi = filterByUgrhis(station)
                        by_city = filterByCity(station)
                    } else {
                        by_reference = false
                    }
                    show = (by_reference && by_legend && by_ugrhi && by_city && by_value)
                    
                } else {
                    if(station.value != null && (station.value >= (store.mainConfigStore.getOption('show_zeros') ? 0 : 1))){
                        by_legend = filterByLegends(station)
                        by_ugrhi = filterByUgrhis(station)
                        by_city = filterByCity(station)
                    } else {
                        by_value = false
                    }
                    show = (by_reference && by_legend && by_ugrhi && by_city && by_value)
                    
                    
                }
            } else {
                show = false
            }

            if(show){
                markers_layer.addLayer(station.marker)
            }
        })
    }

    const hasFluReferenceValues = parameter =>{
        return (parameter.values['extravasation'] || parameter.values['alert'] || parameter.values['emergency'] || parameter.values['attention']) ? true : false
    }

    const filterByUgrhis = station =>{        
        let ugrhi_cod = station.ugrhi_cod || station.station.ugrhi.cod
        let ugrhi_cods = store.fluConfig.getFilterOption('ugrhi_cods')
        return ugrhi_cods.length > 0 ? ugrhi_cods.map(x=>parseInt(x)).includes(ugrhi_cod) : true
    }

    const filterByCity = station =>{
        let city_ibge = station.cod_ibge || station.station.city.cod_ibge
        let city_ibges = store.fluConfig.getFilterOption('city_ibges')
        return city_ibges.length > 0 ? city_ibges.includes(city_ibge) : true
    }

    const filterByLegends = (station)=>{
        let legends = store.fluConfig.getFilterOption('legends')
        let plu_legends = store.fluConfig.getFilterOption('plu_legends')
        let status = markerStatus(station)
        let type = store.mainConfigStore.getType()
        
        if(status && type === 'flu'){
            return legends[status]
        } else if(status && type === 'plu') {
            return plu_legends[status]
        }
    }

    const markerStatus = station =>{
        let reference_value = station.parameter ? hasFluReferenceValues(station.parameter) ? station.parameter : undefined : undefined
        if(store.mainConfigStore.getType() === 'flu'){
            if(reference_value && station.measurements){
                
                let last_measurement = station.measurements.reduce((acc, current) => {
                    const currentTimestamp = new Date(current.date).getTime();
                    const accTimestamp = acc ? new Date(acc.date).getTime() : 0;
                  
                    return currentTimestamp > accTimestamp ? current : acc;
                  }, null)

                station.last_measurement = last_measurement

                if(last_measurement && last_measurement.value){
                    
                    if(last_measurement.value>parseFloat(reference_value.values["extravasation"])){
                        return "extravasation"
                    } else if(last_measurement.value>parseFloat(reference_value.values["emergency"])){
                        return "emergency"
                    } else if(last_measurement.value>parseFloat(reference_value.values["alert"])){
                        return "alert"
                    } else if(last_measurement.value>parseFloat(reference_value.values["attention"])){
                        return "attention"
                    } else {
                        return "ok"
                    }
                } else {
                    return "default"
                }
                
                } else {
                    return "default"
                }
        } else {
            if(parseInt(station.value) <= 10){
                return 'low'
            } else if(parseInt(station.value) <= 30){
                return 'moderate'
            } else if(parseInt(station.value) <= 70){
                return 'high'
            } else {
                return 'very-high'
            }
        }
        
    }

    const creatMarkers = _ =>{
        
        let stations = store.fluConfig.getStations()

        stations.forEach(station=>{
            if(!station.marker && station.value >= 0){
                createMarker(station)
            }
        })
    }

    const createMarker = station =>{
        // console.log(station);
        
        const markerColorByValue = value =>{
            if(parseInt(value) <= 10){
                return colors['low']
            } else if(parseInt(value) <= 30) {
                return colors['moderate']
            } else if(parseInt(value) <= 70){
                return colors['high']
            } else {
                return colors['very-high']
            }
        }

        let marker, icon
        if(store.mainConfigStore.getType()==='flu'){
            icon = L.divIcon({className: `flu-marker-icon flu-marker-icon-${markerStatus(station)}`, status: markerStatus(station)})
        } else {
            let options = {
                isAlphaNumericIcon: true,
                textColor: "white",
                borderWidth: 1,
                text: parseInt(station.value),
                innerIconStyle: 'margin-top:0;font-size:13px;',
                borderColor: 'white',
                backgroundColor: markerColorByValue(station.value)
            };
            icon = L.BeautifyIcon.icon(options)
        }
        

        marker = L.marker([station.latitude || station.station.latitude, station.longitude || station.station.longitude], {icon:icon})

        marker.on('click', _=>{
            store.mapConfigStore.setPopupOptions({type:'station_flu', obj:station, obj_id: station.id, show:true})
        })
        station.marker = marker
    }

    init()

    function init(){
        store.fluConfig.subscribe('SET_STATIONS', stations=>{
            if(map && map._layers && Object.values(map._layers).filter(l=>l.id == 'flu_markers').length == 0){
                markers_layer = L.featureGroup()
                markers_layer.id = 'flu_markers'
                map.addLayer(markers_layer)
            }
            markers_layer.clearLayers()
            context.updateMarkers()
        })

        store.fluConfig.subscribe('SET_STATION_PROP', station=>{
            // console.log(station);
            
            if(station.marker){
                let s = store.fluConfig.getStation(station.station_prefix_id)
                let marker = station.marker

                let icon = marker.getIcon()
                let status = markerStatus(station)
                
                // icon.options.className = `flu-marker-icon flu-marker-icon-${status}`          

                marker.setIcon(icon)

            } else {
                createMarker(station)
            }
        })

        store.fluConfig.subscribe('UPDATE_FILTER_OPTIONS', legends=>{
            context.filterMarkers()
        })

        store.mainConfigStore.subscribe('SET_OPTION', data=>{
            if(data.option === 'hide_all_markers' || data.option === 'show_zeros'){
                context.filterMarkers()
            }
        })

        store.mainConfigStore.subscribe('SET_OPTIONS', data =>{
            if(data.options.filter(x=> (x[0] === 'hide_all_markers' || x[0] === 'show_zeros')).length > 0){
                context.filterMarkers()
            }
        })
    }
}

MarkersComponent.prototype = Object.create(BaseConstructor.prototype)